













































import Vue, { PropType } from "vue"
import { vueWith } from "./../vueWith"


/**
 * 初期化処理
 * created, mounted
 * handler: function idx()
 * initlist()
 *   emit()
 *   handler: function idx()
 *
 * focus inイベント
 * openlist()
 *
 * 入力
 * filter()
 *
 * リストから選択
 * closeList()
 * selectList()
 * handler: function idx()
 *
 * ↑
 * up()
 *
 * ↓
 * down()
 *
 * enter
 * select()
 *
 * focus outイベント
 * closelist()
 *
 * @example
 *  <dropdownlist-component
 *    v-model="targetList[index]"
 *    :placeholder="'商品'"
 *    :index="targetList[index]"
 *    :data="productList"
 *  ></day-component>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: { // 親から渡される値。変更不可
    /** dataに対応するインデックス viewとやり取り時に変換が必要 */
    index: Number,
    placeholder: String,
    data: Array as PropType<Array<{ cd: string, name: string, visible: boolean }>>,
    isNameOnly: Boolean,
  },
  computed: {
    //
  },
  watch: {
    // 親データが変更された
    data: function dt(newData: Array<{ cd: string, name: string }>) {
      // console.log("data change")
      this.filter()
    },
    index: {
      /**
       * 初回
       * 選択項目が変わったとき
       */
      handler: function idx(newData) {
        // console.log("idx change")
        // console.log(newData)
        // 初回とViewDataから選択がインデックスが異なる
        if (this.once) {
          // 1000件以上
          this.viewData = []
          if (this.data.length > 1000) {
            let start = newData
            let end = start + 1000
            // console.log(start)
            // console.log(end)
            if (start + 1000 > this.data.length) {
              start = this.data.length - 1000
              end = this.data.length
            }
            // console.log(start)
            // console.log(end)
            for (let i = start; i < end; i++) {
              const datum = this.data[i]
              this.viewData.push({
                cd: datum.cd,
                name: datum.name,
              })
            }
          } else {
            this.data.forEach((datum) => {
              this.viewData.push({
                cd: datum.cd,
                name: datum.name,
              })
            })
          }
          this.initList(newData)
          this.once = false
        } else {

          if (newData !== -1) {
            // this.inputValue = this.data[newData].cd + ":" + this.data[newData].name
          } else {
            this.inputValue = ""
          }
          // this.selectList(newData)
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      viewData: [] as Array<{ cd: string, name: string }>,
      isOpen: false,
      inputValue: "",
      // viewData: [] as Array<{ cd: string, name: string, visible: boolean }>,
      selectedItem: 0,
      // 変換とエンター処理制御用
      canEnter: false,
      showList: false,
      once: true,
      count: 0,
    }
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    // this.filter("")

  },

  mounted: function mount() {
    // console.log("mounted")
    if (!this.showList) {

      // console.log(this.viewData)
    }
    this.showList = true
  },

  methods: {

    inputText(e: any) {
      // this.$emit("input", e.target!.value)
      // console.log("inputText:" + e.target!.value)
      this.$emit("input", -1)
      // フィルタ 続けて入力したときは一旦処理を保留する
      this.count++
      const cnt = this.count
      setTimeout(() => {
        this.filter(e.target!.value, cnt)
      }, 600)
    },

    openList() {
      // console.log("openList")
      // console.log(this.index)
      // 追加時 空
      if (this.viewData.length === 0) {
        if (this.data.length > 1000) {
          for (let i = 0; i < 1000; i++) {
            const datum = this.data[i]
            this.viewData.push({
              cd: datum.cd,
              name: datum.name,
            })
          }
        } else {
          this.data.forEach((datum) => {
            this.viewData.push({
              cd: datum.cd,
              name: datum.name,
            })
          })
        }
      }

      this.isOpen = true
      if (this.index !== -1) {

        const i = this.viewData.findIndex((datum) => {
          return datum.cd === this.data[this.index].cd
        })
        this.selectedItem = i
      } else {
        this.selectedItem = 0
      }
    },

    closeList() {
      // console.log("closeList")
      // 直後だとリストクリックイベントがうまく働かない
      setTimeout(() => {
        this.isOpen = false
      }, 200)
    },

    /**
     * 表示時のみdataから取得
     */
    initList(index: number) {
      // console.log("initlist")

      // viewDataに一致するものを探す
      // if (index !== -1) {
      //   const i = this.viewData.findIndex((datum) => {
      //     return datum.cd === this.data[index].cd
      //   })
      //   if (this.isNameOnly) {
      //     this.inputValue = this.viewData[index].name
      //   } else {
      //     this.inputValue = this.viewData[index].cd + ":" + this.viewData[index].name
      //   }
      // } else {
      //   this.inputValue = ""
      // }
      if (this.isNameOnly) {
        this.inputValue = this.data[index].name
      } else {
        this.inputValue = this.data[index].cd + ":" + this.data[index].name
      }
      // console.log("initlist")
      // console.log(this.viewData)
      // console.log(this.data[index].cd + ":" + this.data[index].name)
      // console.log(this.inputValue)
      // this.$emit("input", index)
    },

    selectList(index: number) {
      // console.log("selectlist")
      if (index !== -1) {
        if (this.isNameOnly) {
          this.inputValue = this.viewData[index].name
        } else {
          this.inputValue = this.viewData[index].cd + ":" + this.viewData[index].name
        }
      } else {
        this.inputValue = ""
      }
      // console.log(this.inputValue)
      // console.log(index)
      // viewdataからdataへ置き換え

      if (index !== -1) {
        index = this.data.findIndex((datum) => {
          return datum.cd === this.viewData[index].cd
        })
      }
      this.$emit("input", index)
    },

    /** リスト選択移動 上 非表示の場合とばす */
    up() {
      if (this.selectedItem > 0) {
        this.selectedItem--
      }

      // 範囲を超えた場合
      if (!this.viewData[this.selectedItem]) {
        this.selectedItem = this.viewData.length - 1
      }

      // 選択中のリスト位置へスクロール
      const ulElement = this.$refs.list as Element
      const selectedLiElement = ulElement.children[this.selectedItem] as HTMLElement
      ulElement.scrollTo({
        behavior: "smooth",
        left: 0,
        top: selectedLiElement.offsetTop,
      })
      // console.log(this.selectedItem)
      this.selectList(this.selectedItem)
    },
    /** リスト選択移動 下 非表示の場合とばす */
    down() {
      // console.log(this.selectedItem)
      this.selectedItem++

      // 範囲を超えた場合
      if (!this.viewData[this.selectedItem]) {
        // 表示可能な一番下のindexへ移動
        this.selectedItem = this.viewData.length - 1
      }

      // 選択中のリスト位置へスクロール
      const ulElement = this.$refs.list as Element
      const selectedLiElement = ulElement.children[this.selectedItem] as HTMLElement
      ulElement.scrollTo({
        behavior: "smooth",
        left: 0,
        top: selectedLiElement.offsetTop,
      })
      this.selectList(this.selectedItem)
    },

    /** リストを選んでエンターで選択 */
    select() {
      if (!this.canEnter) {
        // 変換処理中は除外
        return
      }
      // console.log("select")
      this.canEnter = false
      this.selectList(this.selectedItem)
      this.closeList()
      // フォーカスを外す
      const inputElement = this.$refs.input as HTMLInputElement
      inputElement.blur()
    },

    /** 入力値によって表示をフィルタする */
    filter(value: string | null = null, count = 0) {
      // console.log("filter")
      if (!value) {
        value = ""
      }
      // カウントが一致しない場合入力中
      if (count !== 0 && count !== this.count) {
        return
      }

      this.showList = false
      this.$nextTick(() => {
        let cnt = 0
        this.viewData = []
        this.data.forEach((datum) => {
          if (cnt > 1000) {
            return
          }

          if (datum.cd.indexOf(value!) !== -1 || datum.name.indexOf(value!) !== -1) {
            this.viewData.push({
              cd: datum.cd,
              name: datum.name,
            })
            cnt++
          }
        })

        this.showList = true

      })
    },


    // 子から呼ばれる ---------------------------------------------

  },
})

